import { useState, useEffect, useCallback } from "react";
import { useSubmitNewsletterSignupMutation } from "../src/services/api";
const LS_KEY = "pc_newsletter_confirmed";
export function useNewsletterSignup(source) {
  const [email, setEmail] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [submitMutation, {
    isLoading: submitting
  }] = useSubmitNewsletterSignupMutation();
  useEffect(() => {
    try {
      setConfirmed(localStorage.getItem(LS_KEY) === "true");
    } catch {
      // SSR or storage unavailable
    }
  }, []);
  const submit = useCallback(async () => {
    if (!email || confirmed || submitting) return;
    try {
      await submitMutation({
        email,
        source,
        website: honeypot || undefined
      }).unwrap();
      setConfirmed(true);
      try {
        localStorage.setItem(LS_KEY, "true");
      } catch {
        // storage unavailable
      }
    } catch {
      // let caller handle via RTK error state if needed
    }
  }, [email, honeypot, source, confirmed, submitting, submitMutation]);
  return {
    email,
    setEmail,
    honeypot,
    setHoneypot,
    confirmed,
    submitting,
    submit
  };
}